import { use } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@components/ui/IconButton/IconButton';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import { CollapseIcon, ExpandIcon } from '@utils/icons';
import { MonitorFullscreenContext } from './MonitorFullscreenContext';

/** Enters or leaves the Monitor's fullscreen; nothing outside the Monitor page. */
export function FullscreenToggle() {
  const { t } = useTranslation();
  const monitorFullscreen = use(MonitorFullscreenContext);
  if (!monitorFullscreen) return null;
  const { fullscreen, toggle, toggleRef } = monitorFullscreen;
  const label = t(fullscreen ? 'monitor.fullscreen.exit' : 'monitor.fullscreen.enter');
  return (
    <Tooltip content={label}>
      <IconButton ref={toggleRef} aria-label={label} onClick={toggle}>
        {fullscreen ? <CollapseIcon size={14} /> : <ExpandIcon size={14} />}
      </IconButton>
    </Tooltip>
  );
}
